import { get_token ,get_user_details} from "@/router";
import Swal from 'sweetalert2';

export default {
  data() {
    return ({
      category_name: '',
      tag_name: new Map(), // Use Map instead of plain object
      categories: [],
      token_exists: false,
      fetched_categories: {},
      selectedCategoryId: null,
      user_details: {
        user_role: ''
      }
    });
  },

  mounted() {
    this.token_exists = get_token();
    this.user_details = get_user_details();
    this.fetch_grouped_tags();
  },

  computed: {
    totalTags() {
      if (!Array.isArray(this.categories)) return 0;

      return this.categories.reduce((total, category) => {
        return total + (Array.isArray(category.tags) ? category.tags.length : 0);
      }, 0);
    }
  },

  methods: {
    fetch_grouped_tags() {
  this.isLoading = true;

  $.ajax({
    url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/get_all_tags/`,
    method: 'GET',
    headers: {
      'Authorization': `Token ${this.getToken()}`,
      'Content-Type': 'application/json'
    },
    success: (response) => {
      if (response.status === "success") {
        const tag_list = response.data.tags;

        // ✅ Use Map instead of plain object
        const grouped = new Map();

        tag_list.forEach(tag => {
          const catId = tag.tag_category.id;
          const catName = tag.tag_category.name;

          if (!grouped.has(catId)) {
            grouped.set(catId, {
              id: catId,
              name: catName,
              tags: []
            });
          }

          grouped.get(catId).tags.push({
            id: tag.id,
            name: tag.name
          });
        });

        this.categories = Array.from(grouped.values());


        // ✅ Initialize tag_name and selected_tags as Maps
        this.tag_name = new Map();
        this.selected_tags = new Map();

        this.categories.forEach(cat => {
          this.tag_name.set(cat.id, '');
          this.selected_tags.set(cat.name, null);
        });
      }
    },
    complete: () => {
      this.isLoading = false;
    }
  });
},


    getToken() {
      return get_token();
    },

    create_form_data(category = null) {
      if (!category) {
        category = this.categories.length > 0 ? this.categories[0] : null;
      }

      if (!category || !Array.isArray(category.tags)) {
        console.warn('No category or category.tags not found.');
        return null;
      }

      const formData = new FormData();


        formData.append('category_name', category.name);

      category.tags.forEach((tag, index) => {
        formData.append(`tags[${index}]`, tag.name);
      });

      return formData;
    },

   create_tag_category() {
    const category = this.categories.find(c => c.id === this.selectedCategoryId);

    if (!category || !category.tags || category.tags.length === 0) {
      Swal.fire('No tags to save', 'Please add at least one tag.', 'info');
      return;
    }

    const formData = new FormData();

    if (String(category.id).length < 10) {
      formData.append('category_id', category.id);
    } else {
      formData.append('category_name', category.name);
    }

    category.tags.forEach((tag, index) => {
      formData.append(`tags[${index}]`, tag.name);
    });

    $.ajax({
      type: "POST",
      url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/create_tag_category/`,
      data: formData,
      processData: false,
      contentType: false,
      headers: {
        'Authorization': `Token ${this.getToken()}`,
      },
      success: (response) => {
        Swal.fire({
          icon: 'success',
          title: 'Success',
          text: response.message,
          showConfirmButton: false,
          timer: 2000
        }).then(() => {
          $("#categoryTagManagerModal").modal("hide");
          this.categories = [];
          this.tag_name = new Map();
          this.selectedCategoryId = null;
        });
      },
      error: (xhr) => {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: xhr.responseJSON?.message || 'Something went wrong.',
        });
      }
    });
},

    handleKeyPress(type, categoryId = null) {
      if (type === 'category') {
        this.addCategory();
      } else if (type === 'tag') {
        this.addTag(categoryId);
      }
    },

     handleTagInputChange(categoryId, value) {
    this.tag_name.set(categoryId, value);
  },

    addCategory() {
      const name = this.category_name.trim();
      if (!name) return;

      const new_category = {
        id: Date.now(),
        name,
        tags: [],
      };

      this.categories.unshift(new_category);
      this.category_name = '';
    },

    delete_category(category_id) {

          Swal.fire({
            title: 'Are you sure?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, delete it!'
          }).then((result) => {
            if (result.isConfirmed) {
              $.ajax({
                type: "DELETE",
                url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/delete_tag_category/`,
                data: JSON.stringify({ category_id: parseInt(category_id) }),

                headers: {
                  'Authorization': `Token ${this.getToken()}`,
                  'Content-Type': 'application/json'
                },
                success: (response) => {
                  const status = response.status;
                  if (status === "success") {
                    this.categories = this.categories.filter(category => category.id !== category_id);
                    Swal.fire({
                      title: 'Deleted!',
                      text: 'The category has been deleted.',
                      icon: 'success',
                      showConfirmButton: false,
                      timer: 1000
                    })
                  } else {
                    Swal.fire(
                      'Failed!',
                      response.message || 'An error occurred. Please try again.',
                      'error'
                    );
                  }
                },
                error: () => {
                  Swal.fire(
                    'Failed!',
                    'An error occurred. Please try again.',
                    'error'
                  );
                }
              });
            }
          });
        },

  addTag(categoryId) {
    const tagName = (this.tag_name.get(categoryId) || '').trim();
    if (!tagName) return;

    const category = this.categories.find(c => c.id === categoryId);
    if (category) {
      category.tags.unshift({
        id: Date.now(),
        name: tagName,
      });

      this.tag_name.set(categoryId, '');
      this.selectedCategoryId = categoryId; // 👈 mark this category as active
    }
  },

    deleteTag(categoryId, tagId) {
      const category = this.categories.find(c => c.id === categoryId);
      if (category) {
        category.tags = category.tags.filter(tag => tag.id !== tagId);
      }
    },
  },
};